import clsx from "clsx";
import { type FC, type ReactNode } from "react";

interface SelectButtonProps {
  className?: string;
  onClick: () => void;
  content: ReactNode;
  isChosen: boolean;
}

export const SelectButton: FC<SelectButtonProps> = (props) => {
  const { className, onClick, content, isChosen } = props;

  return (
    <button
      type="button"
      className={clsx("tab-button", className, { chosen: isChosen })}
      onClick={onClick}
    >
      {content}
    </button>
  );
};
